/* eslint-disable no-unused-vars */
<template>
  <el-dialog
    width="1024px"
    :visible.sync="modelValue"
    @open.once="handleDialogOpen"
    custom-class="relic-detail-base-map"
  >
    <!-- 地图弹窗header -->
    <header class="map-header flex-align">
      <!-- 搜索框 -->
      <div class="map-header__search font-label el-input el-input--suffix">
        <input
          type="text"
          id="search-input"
          autocomplete="off"
          placeholder="关键字搜索"
          class="el-input__inner"
          :disabled="!limitShow"
        />
        <span class="el-input__suffix">
          <span class="el-input__suffix-inner">
            <i class="el-input__icon el-icon-search"></i>
          </span>
        </span>
      </div>

      <el-input
        :disabled="!limitShow"
        v-model="mapCoordinate"
        class="map-header__coordinate font-label"
        placeholder="填写坐标值、或根据地图读取坐标值"
      />
      <el-button
        type="primary"
        class="map-header__action"
        @click="handleConfirmClick"
      >
        确定
      </el-button>
      <el-button
        type="primary"
        class="map-header__action"
        @click="modelValue = false"
      >
        取消
      </el-button>
    </header>

    <!-- 地图弹窗容器 -->
    <div id="map-container" class="map-container"></div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { modelMixin } from '../../assets/js/mixins/model';
import { initAMap, geolocation, getMapCity } from '../../config/AMap';
import { gcj02towgs84, wgs84togcj02 } from '../../config/transformCoodornate';

export default {
  name: 'RelicDetailBaseMap',

  mixins: [modelMixin],
  props: {
    coordinate: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('login', ['limitShow'])
  },
  watch: {
    coordinate: {
      immediate: true,
      handler(newValue) {
        this.mapCoordinate = newValue;
        const lnglat = newValue.split(',');
        const gaodeArr = wgs84togcj02(lnglat[0], lnglat[1]);
        this.gaodeCoordinate = JSON.stringify(gaodeArr);
      }
    }
  },
  // computed: {
  //   coordinate() {
  //     return this.data
  //   }
  // },
  data() {
    return {
      mapSearch: '', // 搜索内容
      mapCoordinate: '', //wgs坐标
      gaodeCoordinate: '', //高德坐标
      geolocation: {}, // 定位信息
      map: null, // 地图实例
      AMap: null, // 地图基类
      searchMarkers: [] // 搜索结果markers
    };
  },

  methods: {
    /**
     * * 地图弹窗打开回调
     */
    handleDialogOpen() {
      this.initMap();
    },

    /**
     * * 初始化地图
     */
    async initMap() {
      const { AMap, map } = await initAMap({
        options: { zoom: 10 },
        version: '2.0',
        container: 'map-container',
        plugins: ['AMap.Geolocation', 'AMap.AutoComplete', 'AMap.PlaceSearch']
      });
      this.AMap = AMap;
      this.map = map;
      this.map.setCenter([120.223637, 29.994095]);
      if (this.limitShow) map.on('click', this.handleMapClick);
      this.initLocation(AMap, map, this.gaodeCoordinate);
      this.initMapSearch(AMap, map);
    },

    /**
     * * 初始化定位
     * @param {String} point
     */
    initLocation(AMap, map, point) {
      point = point ? point : '[120.223637,29.994095]';
      const coordinate = JSON.parse(point);
      const test = new this.AMap.Marker({
        title: name,
        bubble: true,
        position: coordinate,
        content: this.setLocationMarker()
      });
      map.add(test);
      map.setFitView();
    },

    /**
     * * 初始化地图搜索
     */
    async initMapSearch(AMap, map) {
      const { city } = await getMapCity(map);
      AMap.plugin(['AMap.AutoComplete', 'AMap.PlaceSearch'], () => {
        const autoOptions = { city, input: 'search-input' };
        const auto = new AMap.AutoComplete(autoOptions);
        const placeSearch = new AMap.PlaceSearch({ city }); //构造地点查询类
        auto.on('select', ({ poi: { name } }) =>
          placeSearch.search(name, this.handlePlaceSearch)
        ); //注册监听，当选中某条记录时会触发
      });
    },

    /**
     * * 搜索回调
     * @param {string} status 搜索结果状态
     * @param {Object} result
     */
    handlePlaceSearch(status, result) {
      this.map.remove(this.searchMarkers);
      if (status !== 'complete') return;
      this.searchMarkers = result.poiList.pois.map(
        ({ location, name }) =>
          new this.AMap.Marker({
            title: name,
            bubble: true,
            position: location,
            content: this.setLocationMarker()
          })
      );
      this.map.add(this.searchMarkers);
      this.map.setFitView();
    },

    /**
     * * 设置定位marker
     */
    setLocationMarker() {
      const icon = document
        .querySelector('.base-content__mapicon')
        .cloneNode(true);
      icon.classList.add('map-location__marker');
      return icon;
    },

    /**
     * * 地图点击回调
     */
    handleMapClick({ lnglat: { lng, lat } }) {
      // let coodornateArr = gcj02towgs84(lng, lat);
      this.gaodeCoordinate = JSON.stringify([lng, lat]);
      const wgs = gcj02towgs84(lng, lat);
      this.mapCoordinate = wgs.join(',');
    },

    /**
     * * 确定按钮点击回调
     */
    handleConfirmClick() {
      this.modelValue = false;
      this.$emit('onConfirmClick', this.mapCoordinate, this.gaodeCoordinate);
    }
  }
};
</script>

<style lang="scss">
.relic-detail-base-map {
  .el-dialog {
    &__header {
      display: none;
    }
    &__body {
      padding: 50px 12px 12px;
    }
  }
  .map {
    &-header {
      &__search {
        margin-right: 38px;
        width: 250px;
      }
      &__coordinate {
        margin-right: 40px;
        flex: 1;
      }
      &__action {
        height: 24px;
      }
      .el-input {
        &__inner {
          padding: 0 3px;
          height: 24px;
          line-height: 24px;
          border-radius: 0;
        }
        &__icon {
          font-size: 18px;
          color: $color-primary;
          line-height: 24px;
        }
      }
    }
    &-container {
      margin-top: 12px;
      height: 500px;
    }
  }
  #map-container {
    .map {
      &-location {
        &__marker {
          position: unset;
          transform: unset;
          .iconfont {
            font-size: 30px;
          }
        }
      }
    }
  }
}
.amap-sug-result {
  z-index: 9999;
}
</style>
